import React from 'react';
import SmartImage from '../../subcomponents/SmartImage';
import findAltText from '../../utils';

import './seo.scss';

const SEO = ({
  element, campaignType, order, url, version,
 }) => {
  const {
    titleColor, 
    textColor, 
    mobileTitleColor, 
    mobileTextColor, 
    useMobileText, 
    anchorName,
    hide, 
    content,
    backgroundImage, 
    backgroundContent,
    type,
    noBackground, 
    useGradient, 
    backgroundGradient, 
    gradientDirection,
    seoNumber,
   } = element;
   let { backgroundColor } = element;
   if (campaignType === 'general' && !noBackground) backgroundColor = '';
   const { slug, imagePattern } = url;
  const translations = window.campaign_data.campaign_translations.blocks;
  const uppercaseLetters = url.generalData ?
  url.generalData.uppercaseLetters
  : false;

  let displayTitleColor = titleColor;
  let displayTextColor = textColor;
  if (useMobileText && window.innerWidth < 768) displayTextColor = mobileTextColor;
  if (useMobileText && window.innerWidth < 768) displayTitleColor = mobileTitleColor;

  const stylelist = ['mainWidth'];
  if (campaignType === 'sale' || noBackground) { stylelist.push('sale'); }
  if (backgroundImage) { stylelist.push('background-image-style'); }

  const classes = uppercaseLetters && campaignType === 'general' ? 'seo-title title title--uppercase' : 'seo-title title';
  let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
        }
  let component = null;
  if (!hide) {
    component = (
      <section
        id={anchorName || ''}
        className={`component seo-section ${(!noBackground || backgroundImage) && 'seo-section-noPadding'}`}
        style={styler}
        dataorder={order}
        datatype={type}
      >
        {(backgroundImage || (campaignType === 'general' && !noBackground)) &&
          <SmartImage
            className={campaignType === 'general' ? 'heightBackground' : 'navigation-image'}
            slug={slug}
            name={campaignType === 'general' ? `380-seo${seoNumber}${imagePattern}` : `${backgroundContent}.jpg`}
            version={version}
            campaignType={campaignType}
            alt={findAltText(`SEO Background ${seoNumber}`, translations[`${content}title`])}
          />
        }
        <div className={stylelist.join(' ')}>
          <div className={campaignType === 'general' && !noBackground ? 'div-absolute' : ''}>
            <div
              className={classes}
              style={{ color: displayTitleColor }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                  __html: translations[`${content}title`] || translations.seotitle,
                }}
            />

            <div
              className="seo-text"
              style={{ color: displayTextColor }}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                  __html: translations[`${content}text`] || translations.seotext,
                }}
            />
          </div>
        </div>
      </section>
    );
  }

  return (
    component
    );
 };

 export default SEO;
